module.exports = __webpack_public_path__ + "img/undraw_quite_town_mg2q.0fc297c8.svg";